import { render, staticRenderFns } from "./RewardType.vue?vue&type=template&id=00c62368&"
import script from "./RewardType.vue?vue&type=script&lang=js&"
export * from "./RewardType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports